import { Component } from 'san';
import { ISchedule, IScheduleTimesCallback } from 'src/models';
import scheduleTimesServices from 'src/services/scheduleTimes.services';
import Schedule from '../Schedule/Schedule';
import * as _ from 'lodash';

export default class Schedules extends Component {
    constructor(options: any) {
        super(options);
    }

    static components = {
        'ui-schedule': Schedule,
    }

    initData(): {
        schedules: ISchedule[];
        schedule_account: string;
        schedule_account_name: string;
        target_end_time: string;
    } {
        return {
            schedules: [],
            schedule_account: '',
            schedule_account_name: '',
            target_end_time: ''
        };
    }

    inited() {
        this.initSchedules()
    }

    initSchedules() {
        const schedule = {
            title: '',
            schedule_account: this.data.get('schedule_account'),
            schedule_account_name: this.data.get('schedule_account_name'),
            target_end_time: this.data.get('target_end_time'),
            remark: '' // 调度要求
        }
        this.data.set('schedules', [schedule]);
    }

    //#region owner调用
    getDataSync(): { items: ISchedule[] } {
        return { items: this.data.get('schedules') };
    }
    //#endregion

    toAddSchedules() {
        scheduleTimesServices.show(this.addSchedules);
    }

    addSchedules: IScheduleTimesCallback = (times) => {
        const schedule = {
            title: '',
            schedule_account: '',
            schedule_account_name: '',
            target_end_time: '',
            remark: '' // 调度要求
        }
        const schedules = _.fill(Array(times), schedule);
        this.data.set('schedules', _.concat(this.data.get('schedules'), schedules));
    }

    copySchedules(data: {schedule: ISchedule, times: number}) {
        const schedules = _.fill(Array(data.times), data.schedule);
        this.data.set('schedules', _.concat(this.data.get('schedules'), schedules));
    }

    deleteSchedule(index: number) {
        this.data.removeAt('schedules', index);
    }
}